import Qwery from 'qwery'
import Bean from 'bean'
import { preEasysize } from './components/easysize-pre-start'
import { emitter, loadEasySizeButton, setLanguage } from './components/features'
import { removeElementsById, removeElementsByClassName } from './components/utilities'
import 'promise-polyfill/src/polyfill'

(() => {
  if (window.EasysizeWrapperInitiated) {
    return
  }

  window.EasysizeWrapperInitiated = true
  let params = preEasysize()

  window.EasySize = function (opts) {
    return {
      start: () => {
        System.import('./components/easysize').then(module => {
          let es = module.EasySize(opts, params) // eslint-disable-line
          es.start()

          window.EasySize = function (opts) {
            return module.EasySize(opts)
          }
        })
      },
      sizeChangedTo: function sizeChangedTo (size) {
        emitter.emit('easysize_size_selected', size)
        params.shop.selected_size = size
      },
      embed: (config) => {
        if (params.product.supported) {
          require.ensure('./components/size-advisor-qa', (require) => {
            require('./components/size-advisor-qa').embed(params, config)
          })
        } else {
          console.warn('[Easysize] trying to open widget when product is not supported')
        }
      },
      update_product: (config) => {
        params.product = Object.assign(params.product, config)
      },
      open: (config) => {
        // Prevent widget from being opened multiple times
        if (document.getElementById('easysize_popup')) {
          return
        }

        params.shop.custom_css = config.custom_css || params.shop.custom_css

        if (params.product.supported) {
          require.ensure('./components/size-advisor-qa', (require) => {
            require('./components/size-advisor-qa').startQaAdvisor(params)
          })
        } else {
          console.warn('[Easysize] trying to open widget when product is not supported')
        }
      },
      refresh: () => {
        removeElementsByClassName('es-selected')
        removeElementsByClassName('es-recommended')
        removeElementsByClassName('easysize_button')
        removeElementsById('esid-input')

        document.body.classList.remove('es-recommended-size')
        document.body.classList.remove('es-selected-size')
        document.body.classList.remove('es-loaded')

        params.elements.add_to_cart_button = Qwery(params.shop.add_to_cart_btn_selector)[0]
        params.elements.button_placeholder = Qwery(params.shop.easysize_button_placeholder_selector.constructor === Array ? params.shop.easysize_button_placeholder_selector[0] : params.shop.easysize_button_placeholder_selector)[0]
        params.elements.size_dropdown = Qwery(params.shop.size_dropdown_selector)[0]

        if (params.product.brand_id) {
          loadEasySizeButton(params)
          if (params.easysize.calculated_size) {
            emitter.emit('easysize-size-selected')
          }
        }
      },
      preselectSize: () => {
        if (params.easysize.calculated_size) {
          params.shop.update_size_dropdown(params.easysize.calculated_size, params)
          emitter.emit('easysize-size-selected')
        }
      },
      isLoaded: () => {
        return params.easysize.is_loaded
      },
      setLanguage: (language) => {
        setLanguage(params, language)
      }
    }
  }

  window.dispatchEvent(new Event('easysize_ready', {'bubbles': true, 'cancelable': false}))
})()



// WEBPACK FOOTER //
// ./src/js/index.js